function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_1557",
  "data-name": "Grupo 1557",
  transform: "translate(-298.191 -43.703)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_470",
  "data-name": "Grupo 470"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1388",
  "data-name": "Ret\\xE2ngulo 1388",
  width: 0.996,
  height: 15.3,
  transform: "translate(303.92 45.105)",
  fill: "#0055c6",
  stroke: "#fafafa",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_471",
  "data-name": "Grupo 471"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_836",
  "data-name": "Caminho 836",
  d: "M309.237,50.565l-4.879-4.76L299.6,50.561l-.7-.7,5.451-5.451,5.583,5.447Z",
  fill: "#0055c6",
  stroke: "#fafafa",
  strokeWidth: 1
})));

function SvgGoUpArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.449,
    height: 17.203,
    viewBox: "0 0 12.449 17.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoUpArrow);
export default __webpack_public_path__ + "static/media/go-up-arrow.e9ad5a6e.svg";
export { ForwardRef as ReactComponent };